<script lang="ts">
    import { _ } from "svelte-i18n"
    import { postMail } from "../../api"
    import { navigateTo } from "../../helper"
    import { newNotification, removeNotification } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"

    export let lang = "de"

    let username = ""

    let notif: NotificationEntry
    let submitLoading = false
    function sendPwMail() {
        submitLoading = true
        removeNotification(notif)

        postMail("pwReset", { username }, true)
            .then(() => {
                notif = newNotification({
                    class: "success",
                    html: $_("account.passwordResetLinkSent"),
                    timeout: 10000,
                })

                username = ""
                navigateTo("/de/login")
            })
            .catch((e) => {
                notif = newNotification({
                    class: "error",
                    html: $_("account.errorOccurred"),
                    timeout: 10000,
                    removeOnNewLocation: true,
                })
            })
            .finally(() => {
                submitLoading = false
            })
    }
</script>

<section id="login" class="section_padding" data-lang="{lang}">
    <div class="container">
        <h1>{$_("account.resetPassword")}</h1>
        <form on:submit|preventDefault="{sendPwMail}">
            <div class="row">
                <div class="col-md-12">
                    <input
                        type="text"
                        placeholder="{$_('account.user')}"
                        required
                        bind:value="{username}"
                        name="username"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 flexstart"></div>
                <div class="col-md-6 flexend">
                    {#if submitLoading}
                        <MiniLoader />
                    {:else}
                        <button class="btn" type="submit">{$_("general.send")}</button>
                    {/if}
                </div>
            </div>
        </form>
    </div>
</section>
